import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Swal from "sweetalert2";
import { sendPostulationsToHead } from "./Axios";

const SendToHeadModal = ({ courseId, _applicantsSelected, reloadQuery }) => {
  const [modal, setModal] = useState(false);
  const [processing, setProcessing] = useState(false);

  const toggle = () => setModal(!modal);

  const getPostulationIds = () => {
    return _applicantsSelected
      .map(a =>
        a.postulation_id ||
        a.postulationId ||
        a.postulation?.id ||
        a.id ||
        a.value
      )
      .filter(Boolean);
  };

  const buildHtmlMessage = (sent = [], alreadySent = [], errorMsg = "") => {
    let html = "";
    if (errorMsg) {
      html += `<div style="margin-bottom:10px;"><b style='color:#d33;'>${errorMsg}</b></div>`;
    }
    if (sent.length > 0) {
      html += "<b style='color:#11804c;'>Candidatos enviados con éxito a jefatura:</b>";
      html += "<ul style='margin-bottom:10px;'>";
      sent.forEach(a => {
        html += `<li>${a.full_name} (<a href="mailto:${a.email}">${a.email}</a>)</li>`;
      });
      html += "</ul>";
    }
    if (alreadySent.length > 0) {
      html += "<b style='color:#b87b2a;'>Estos candidatos ya habían sido enviados:</b>";
      html += "<ul style='margin-bottom:10px;'>";
      alreadySent.forEach(a => {
        html += `<li>${a.full_name} (<a href="mailto:${a.email}">${a.email}</a>)</li>`;
      });
      html += "</ul>";
    }
    if (!html) {
      html = "<i>No hay postulantes nuevos para enviar.</i>";
    }
    return html;
  };

  const handleSubmit = () => {
    if (_applicantsSelected.length === 0) {
      Swal.fire("Error", "Debe seleccionar candidatos.", "error");
      return;
    }

    const postulationIds = getPostulationIds();
    if (postulationIds.length === 0) {
      Swal.fire(
        "Error",
        "No se pudieron determinar los IDs de postulación de los candidatos seleccionados.",
        "error"
      );
      return;
    }

    setProcessing(true);
    sendPostulationsToHead(courseId, postulationIds, response => {
      setProcessing(false);

      if (response.status !== 200) {
        const errorMsg = response.data?.error || "Ocurrió un error inesperado.";
        const alreadySent = response.data?.already_sent || [];
        Swal.fire({
          title: "Envío a Jefatura",
          html: buildHtmlMessage([], alreadySent, errorMsg),
          icon: "warning",
          confirmButtonText: "Aceptar"
        });
        return;
      }

      const sent = response.data?.sent || [];
      const alreadySent = response.data?.already_sent || [];
      Swal.fire({
        title: "Envío a Jefatura",
        html: buildHtmlMessage(sent, alreadySent),
        icon: "success",
        confirmButtonText: "Aceptar"
      }).then(() => {
        toggle();
        reloadQuery && reloadQuery();
      });
    });
  };

  return (
    <>
      <Button color="warning" outline onClick={toggle}>
        Enviar a jefatura
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Enviar a Jefatura</ModalHeader>
        <ModalBody>
          ¿Está seguro que desea enviar los postulantes seleccionados a la jefatura?
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmit} disabled={processing}>
            {processing ? "Enviando..." : "Confirmar"}
          </Button>
          <Button color="danger" onClick={toggle} disabled={processing}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SendToHeadModal;
